import { render, staticRenderFns } from "./info-ruzhi-dialog.vue?vue&type=template&id=69108d3a&scoped=true"
import script from "./info-ruzhi-dialog.vue?vue&type=script&lang=js"
export * from "./info-ruzhi-dialog.vue?vue&type=script&lang=js"
import style0 from "./info-ruzhi-dialog.vue?vue&type=style&index=0&id=69108d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69108d3a",
  null
  
)

export default component.exports